import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgShareAndroid({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 6c0 .205.02.405.06.598l-5.148 3.09a3 3 0 10-.002 4.626l5.15 3.088a3 3 0 101.03-1.715L9.939 12.6a3.013 3.013 0 000-1.196l5.15-3.09A3 3 0 1014 6zm4 0a1 1 0 11-2 0 1 1 0 012 0zm0 12a1 1 0 11-2 0 1 1 0 012 0zM7 13a1 1 0 100-2 1 1 0 000 2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgShareAndroid
